import { MESSAGING_CLIENT_ELEMENT_ID } from '../../constants/index';
import { modifier } from 'ember-modifier';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import Avatar from '../avatar.gjs';
import Component from '@glimmer/component';
import styles from './item-content.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class ContactListItemItemContent extends Component {
  @tracked isTooltipShown = false;

  get isClient() {
    return this.args.contact?.isClient === true;
  }

  get isCouple() {
    return this.args.contact?.members?.length === 2;
  }

  get users() {
    return this.args.contact?.members;
  }

  get scopeIndicatorType() {
    return this.isClient ? 'messaging-client-icon' : 'messaging-user-icon';
  }

  get hasConflicts() {
    return this.args.contact?.conflicts?.length > 0;
  }

  syncTooltipShown = isShown => {
    this.isTooltipShown = isShown;
  };

  // Only listens while the tooltip is open
  // Scoped to the addon root so consuming app scrolls don't dismiss the tooltip.
  hideTooltipOnScroll = modifier((_element, [isShown, hide]) => {
    if (!isShown) {
      return;
    }

    const root = document.getElementById(MESSAGING_CLIENT_ELEMENT_ID);
    if (!root) {
      return;
    }

    root.addEventListener('scroll', hide, { capture: true, passive: true });
    return () => root.removeEventListener('scroll', hide, { capture: true });
  });

  <template>
    <div class={{styles.component}}>
      <Avatar @users={{this.users}} @isCouple={{this.isCouple}} />
      <div class="item-details">
        <div class="top-line">
          <span class="user-names {{if @isNotPermitted 'not-permitted'}}" data-test-user-names>
            {{@userNames}}
          </span>
          {{#if @groupMessagingEnabled}}
            <span class="scope-indicator {{this.scopeIndicatorType}}" data-test-scope-indicator>
              {{svgJar this.scopeIndicatorType}}
            </span>
          {{/if}}
        </div>
        {{#if @isNotPermitted}}
          <span class="not-permitted-notice" data-test-not-permitted-notice>
            {{t "emc.contact_list_item.not_permitted"}}
            {{#if this.hasConflicts}}
              -
              <span
                role="button"
                class="not-permitted-details"
                tabindex="0"
                data-test-not-permitted-details
              >
                {{t "emc.contact_list_item.show_details"}}

                <AttachTooltip
                  @animation="fade"
                  @arrow={{true}}
                  @autoUpdate={{true}}
                  @class="emc-tooltip"
                  @hideOn="focusout clickout escapekey"
                  @onChange={{this.syncTooltipShown}}
                  @placement="bottom"
                  @showOn="focus click"
                  as |tooltip|
                >
                  <div {{this.hideTooltipOnScroll this.isTooltipShown tooltip.hide}}>
                    {{#each @contact.conflicts as |conflict|}}
                      <p class="emc-tooltip-item" data-test-not-permitted-reason>
                        {{conflict}}
                      </p>
                    {{/each}}
                  </div>
                </AttachTooltip>
              </span>
            {{/if}}
          </span>
        {{/if}}
      </div>
    </div>
  </template>
}
